// import React, { useState, useEffect } from 'react';
// import { Button, Form, Spinner } from 'react-bootstrap';
// import axios from 'axios';

// const Step2 = ({ updateFormData, formData }) => {
//     const [loading, setLoading] = useState(true);
//     const [addressData, setAddressData] = useState({
//         country: '',
//         region: '',
//         city: '',
//         postal: '',
//         locality: '',
//     });

//     useEffect(() => {
//         // Fetch address data using ipinfo API
//         const fetchAddressData = async () => {
//             try {
//                 // First API call
//                 const ipInfoResponse = await axios.get('https://ipinfo.io/json?token=50e340973fcdd8');
//                 const { ip, city, region, postal } = ipInfoResponse.data;

//                 // Second API call
//                 const ipApiResponse = await axios.get(`http://ip-api.com/json/${ip}`);
//                 const { regionName, zip, country } = ipApiResponse.data;

//                 // Set fetched address data
//                 setAddressData({
//                     country: country,
//                     region: regionName || region,
//                     city: city,
//                     postal: zip || postal,
//                     locality: formData.locality || '',
//                 });
//             } catch (error) {
//                 console.error('Error fetching address data:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAddressData();
//     }, [formData.locality]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setAddressData({ ...addressData, [name]: value });
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         updateFormData(addressData);
//     };

//     if (loading) {
//         return <Spinner animation="border" variant="primary" />;
//     }

//     return (
//         <Form onSubmit={handleSubmit}>
//             <h3 className='mt-4'>Step 2: Address</h3>

//             {/* Country */}
//             {/* Locality */}
//             <Form.Group>
//                 <p className="mt-3">Locality</p>
//                 <Form.Control
//                     type="text"
//                     name="locality"
//                     value={addressData.locality}
//                     onChange={handleChange}
//                     required
//                 />
//             </Form.Group>

//             {/* City */}
//             <Form.Group>
//                 <p className="mt-3">City</p>
//                 <Form.Control
//                     type="text"
//                     disabled
//                     name="city"
//                     value={addressData.city}
//                     onChange={handleChange}
//                     required
//                 />
//             </Form.Group>

//              {/* State/Region */}
//              <Form.Group>
//                 <p className="mt-3">State/Region</p>
//                 <Form.Control
//                     type="text"
//                     name="region"
//                     disabled
//                     value={addressData.region}
//                     onChange={handleChange}
//                     required
//                 />
//             </Form.Group>

//             <Form.Group>
//                 <p className="mt-3">Country</p>
//                 <Form.Control
//                     type="text"
//                     name="country"
//                     disabled
//                     value={addressData.country}
//                     onChange={handleChange}
//                     required
//                 />
//             </Form.Group>



//             {/* Postal Code */}
//             <Form.Group>
//                 <p className="mt-3">Postal Code</p>
//                 <Form.Control
//                     type="text"
//                     name="postal"
//                     value={addressData.postal}
//                     onChange={handleChange}
//                     required
//                 />
//             </Form.Group>



//             {/* Submit Button */}
//             <Button type="submit" className='mt-3' variant="primary" style={{ float: "right" }}>
//                 Next
//             </Button>
//         </Form>
//     );
// };

// export default Step2;

import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { getCity, getCountries, getState } from "../../../../hooks/Tokenhook";

const Step2 = ({ formData, updateFormData, nextStep, prevStep }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [addressData, setAddressData] = useState({
        locality: formData.locality || "",
        city: formData.city || "",
        region: formData.state || "",
        country: formData.country || "",
        postal: formData.postal || "",
    });

    const [error, setError] = useState("");

    // Fetch countries on component load
    useEffect(() => {
        fetchCountries();
    }, []);
    const fetchCountries = async () => {
        try {
            const data =   await getCountries()
            console.log("data", data);
                setCountries(data);
 
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };

    // Fetch states based on selected country
    useEffect(() => {
        if (addressData.country !== "") {
            const fetchStates = async () => {
                try {
                    // const response = await fetch(
                    //     `http://universities.hipolabs.com/search?country=${addressData.country}`
                    // );
                    // const data = await response.json();
                    // const uniqueStates = [
                    //     ...new Set(data.map((university) => university["state-province"])),
                    // ].filter((state) => state);
                    await getState(addressData.country).then((data) => {
                        console.log("States", data);
                        setStates(data);
                    })
                } catch (error) {
                    console.error("Error fetching states:", error);
                }
            };
            console.log("States");

            fetchStates();
            setAddressData({ ...addressData, region: "", city: "" });
            setCities([]);
        }
    }, [addressData.country]);

    // Fetch cities based on selected state
    useEffect(() => {
        if (addressData.region) {
            const fetchCities = async () => {
                try {
                    console.log("loading ...");
                    const cities = await getCity(addressData.region) 
                    console.log("cities", cities);
                    setCities(cities);
                } catch (error) {
                    console.error("Error fetching cities:", error);
                }
            };
            fetchCities();
            setAddressData({ ...addressData, city: "" });
        }
    }, [addressData.region]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddressData({ ...addressData, [name]: value });
        updateFormData({ ...formData, [name]: value });
        setError("");
    };

    const handleCountryChange = (e) => {
        setAddressData({ ...addressData, country: e.target.value, region: "", city: "" });
        updateFormData({ ...formData, country: e.target.value, state: "", city: "" });
        setError("");
    };

    const handleStateChange = (e) => {
        if (!addressData.country) {
            setError("Please select a country first.");
            return;
        }
        setAddressData({ ...addressData, region: e.target.value, city: "" });
        updateFormData({ ...formData, state: e.target.value, city: "" });
        setError("");
    };

    const handleCityChange = (e) => {
        if (!addressData.region) {
            setError("Please select a state first.");
            return;
        }
        setAddressData({ ...addressData, city: e.target.value });
        updateFormData({ ...formData, city: e.target.value });
        setError("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!addressData.country || !addressData.region || !addressData.city) {
            setError("Please complete all required fields.");
            return;
        }
        nextStep();
    };
    console.log("countries", formData, states);

    return (
        // <div className="container">
        // <Form className="box mt-4" onSubmit={handleSubmit}>
        //     <h3 className="mt-4">Step 2: Address</h3>

        //     {error && <p style={{ color: "red" }}>{error}</p>}

        //     {/* Country */}
        //     <Form.Group>
        //         <p className="mt-3">Country</p>
        //         <Form.Select
        //             name="country"
        //             value={addressData.country}
        //             onChange={handleCountryChange}
        //             required
        //         >
        //             <option value="">Select a country</option>
        //             {countries.map((country, index) => (
        //                 <option key={index} value={country.phonecode}>
        //                     {country.name}
        //                 </option>
        //             ))}
        //         </Form.Select>
        //     </Form.Group>

        //     {/* State/Region */}
        //     <Form.Group>
        //         <p className="mt-3">State/Region</p>
        //         <Form.Select
        //             name="region"
        //             value={addressData.region}
        //             onChange={handleStateChange}
        //             disabled={!addressData.country}
        //             required
        //         >
        //             <option value="">Select a state</option>
        //             {states.map((state, index) => (
        //                 <option key={index} value={state.state_name}>
        //                     {state.name}
        //                 </option>
        //             ))}
        //         </Form.Select>
        //     </Form.Group>

        //     {/* City */}
        //     <Form.Group>
        //         <p className="mt-3">City</p>
        //         <Form.Select
        //             name="city"
        //             value={addressData.city}
        //             onChange={handleCityChange}
        //             disabled={!addressData.region}
        //             required
        //         >
        //             <option value="">Select a city</option>
        //             {cities.map((city, index) => (
        //                 <option key={index} value={city.city_name}>
        //                     {city.city_name}
        //                 </option>
        //             ))}
        //         </Form.Select>
        //     </Form.Group>

            // {/* Locality */}
            // <Form.Group>
            //     <p className="mt-3">Locality</p>
            //     <Form.Control
            //         type="text"
            //         name="locality"
            //         value={addressData.locality}
            //         onChange={handleChange}
            //         required
            //     />
            // </Form.Group>

        //     {/* Postal Code */}
        //     <Form.Group>
        //         <p className="mt-3">Postal Code</p>
        //         <Form.Control
        //             type="text"
        //             name="postal"
        //             value={addressData.postal}
        //             onChange={handleChange}
        //             required
        //         />
        //     </Form.Group>

        //     {/* Submit Button */}
        //     <div className="mt-3">
        //         <Button variant="secondary" onClick={prevStep} className="me-2">
        //             Previous
        //         </Button>
        //         <Button type="submit" variant="primary">
        //             Next
        //         </Button>
        //     </div>
        // </Form>
        // </div>
        
        <div className="container">
        <Form className="box mt-4" onSubmit={handleSubmit}>
            <h3 className="mt-4">Step 2: Address</h3>

            {error && <p style={{ color: "red" }}>{error}</p>}

            {/* 
            {/* Postal Code */}
            <Form.Group>
                <p className="mt-3">Country </p>
                <Form.Control
                    type="text"
                    name="country"
                    value={addressData.country}
                    onChange={handleChange}
                    required
                />
            </Form.Group>
            <Form.Group>
                <p className="mt-3">State </p>
                <Form.Control
                    type="text"
                    name="region"
                    value={addressData.region}
                    onChange={handleChange}
                    required
                />
            </Form.Group><Form.Group>
                <p className="mt-3">City</p>
                <Form.Control
                    type="text"
                    name="city"
                    value={addressData.city}
                    onChange={handleChange}
                    required
                />
            </Form.Group>
              {/* Locality */}
              <Form.Group>
                <p className="mt-3">Locality</p>
                <Form.Control
                    type="text"
                    name="locality"
                    value={addressData.locality}
                    onChange={handleChange}
                    required
                />
            </Form.Group>
            <Form.Group>
                <p className="mt-3">Postal Code</p>
                <Form.Control
                    type="text"
                    name="postal"
                    value={addressData.postal}
                    onChange={handleChange}
                    required
                />
            </Form.Group>
            {/* Submit Button */}
            <div className="mt-3">
                <Button variant="secondary" onClick={prevStep} className="me-2">
                    Previous
                </Button>
                <Button type="submit" variant="primary">
                    Next
                </Button>
            </div>
        </Form>
        </div>
    );
};

export default Step2;
